export const isValidPhoneNumber = (phoneNumber: string) =>
  phoneNumber?.toLowerCase().match(/^\+\d{1,3}\s?\d?(\s?\d{1,13}){6,}?/)
